export default __webpack_public_path__ + "static/media/rambouillet02.63ab7aa4.jpg";